import ENUM from './enum'
import { getRiskList } from '@/api/domain/orders'
import { operateMaxShowLength } from '@/store/dict/config'
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'

// 预警默认阈值
export const THRESHOLD_DEFAULT = [30, 50, 70, 100]
const all = { label: '全部', value: '' }
export default function () {
  return {
    configData: {
      formData: {
        list: [
          {
            el: 'select',
            itemConfig: {
              label: '车牌号',
              prop: 'carId',
            },
            elConfig: {
              filterable: true,
              remote: true,
              'reserve-keyword': true,
              clearable: true,
              placeholder: '请输入',
              'remote-method':
                (query) => {
                  this.remoteMethod(query)
                },
              options: {
                label: 'plateNo',
                value: 'id',
                list: [],
              },
            },
          },
          {
            el: 'select',
            itemConfig: {
              label: '客户名称',
              prop: 'customerId',
            },
            elConfig: {
              jsxRender: (option) => {
                return <CustomerNameOptionItem data={option} />
              },
              filterable: true,
              remote: true,
              'reserve-keyword': true,
              clearable: true,
              placeholder: '请输入',
              'remote-method':
                (query) => {
                  this.loadNameData(query)
                },
              options: {
                label: 'customerName',
                value: 'id',
                list: [],
              },
            },
          },
          {
            el: 'input',
            itemConfig: {
              label: '订单ID',
              prop: 'orderId',
            },
            directives: [{ name: 'number', arg: 'integer', value: 9 }],
          },
          {
            el: 'select',
            itemConfig: {
              // 审批时间区间
              label: '预警状态',
              prop: 'state',
            },
            elConfig: {
              defaultValue: 0,
              options: {
                label: 'label',
                value: 'value',
                list: [all, ...this.dictParseList(ENUM.state)],
              },
            },
          },
          {
            el: 'select',
            itemConfig: {
              // 审批时间区间
              label: '风险等级',
              prop: 'level',
            },
            elConfig: {
              options: {
                label: 'label',
                value: 'value',
                list: [all, ...this.dictParseList(ENUM.level)],
              },
            },
          },
          {
            el: 'date-picker',
            itemConfig: {
              // 审批时间区间
              label: '预警开始时间',
              prop: 'time',
            },
            elConfig: {
              type: 'datetimerange',
              'range-separator': '至',
              'start-placeholder': '开始日期',
              'end-placeholder': '结束日期',
              format: 'yyyy-MM-dd HH:mm',
            },
          },
        ],
        dealWithSearch: this.getParams,
      },
      tableData: {
        columns: [
          {
            name: 'plateNo',
            columnProps: {
              label: '车牌号',
              prop: 'plateNo',
              width: 100,
            },
          },
          {
            name: 'orderId',
            columnProps: {
              label: '订单id',
              prop: 'orderId',
              width: 100,
            },
          },
          {
            name: 'orderState',
            columnProps: {
              label: '订单状态',
              prop: 'orderState',
              width: 100,
            },
          },
          {
            name: 'customerName',
            columnProps: {
              label: '司机姓名',
              prop: 'customerName',
            },
          },
          {
            name: 'customerTel',
            columnProps: {
              label: '联系方式',
              prop: 'customerTel',
              width: 110,
            },
          },
          {
            name: 'rentCategory',
            columnProps: {
              label: '合作模式',
              prop: 'rentCategory',
            },
          },
          {
            name: 'warnLevel',
            columnProps: {
              label: '风险等级',
              prop: 'warnLevel',
              width: 100,
              sortable: 'custom',
            },
            render: ({ row }) => {
              return this.$createElement('el-tag', {
                attrs: {
                  style: row.levelCode === 4 ? 'color:red;border-color:red' : '',
                  effect: 'plain',
                  type: ENUM.bgColor[row.levelCode],
                  color: ENUM.bgColor[row.levelCode],
                },
              }, row.warnLevel)
            },
          },
          {
            name: 'depositRatio',
            columnProps: {
              label: '已占押金比例',
              prop: 'depositRatio',
              width: 140,
              sortable: 'custom',
            },
          },
          {
            name: 'startTime',
            columnProps: {
              label: '预警开始时间',
              prop: 'startTime',
              width: 160,
              sortable: 'custom',
            },
          },
          {
            name: 'modifyTime',
            columnProps: {
              label: '预警更新时间',
              prop: 'modifyTime',
              width: 160,
            },
          },
          {
            name: 'endTime',
            columnProps: {
              label: '预警结束时间',
              prop: 'endTime',
              width: 160,
            },
          },
          {
            name: 'warnDuration',
            columnProps: {
              label: '预警时长',
              prop: 'warnDuration',
              width: 160,
              sortable: 'custom',
            },
          },
          {
            name: 'warnState',
            columnProps: {
              label: '预警状态',
              prop: 'warnState',
            },
          },
          {
            name: 'operate',
            columnProps: {
              label: '操作',
              width: 240,
              fixed: 'right',
            },
            maxShowLength: operateMaxShowLength,
            getOperateList: ({ row }) => {
              const arr = []
              if (this.judgePermission('under_lease_driver_risk_control_detail')) {
                arr.push({
                  name: 'detail',
                  label: '详情',
                  action: () => this.lookDetail(row),
                })
              }
              if (this.judgePermission('under_lease_driver_risk_control_follow') && row.stateCode !== 1) {
                arr.push({
                  name: 'followUp',
                  label: '跟进',
                  action: () => this.followUp(row),
                })
              }
              return arr
            },
            type: 'operate',
          },
        ],
        pagination: {
          pageSizes: [10, 20, 30, 50],
        },
        attrs: {},
        apiFn: getRiskList,
      },
    },
  }
}
